import { useEffect, useState } from 'react'
import { errorLogger } from '../../../api/services'

// This function can be different for repos: school-store-ui/package-browse-ui/product-browse-ui
const sendReportError = (faultDetails) => {
    errorLogger(faultDetails, false)
}

// Comment: Checks whether API response is empty (array or object)
const isEmptyResponse = (result) => {
    if (Array.isArray(result)) {
        return result.length === 0
    }

    if (result && typeof result === 'object') {
        return Object.keys(result).length === 0
    }

    return true
}

const normalizeError = (err) => ({
    message: err?.message,
    stack: err?.stack,
})

export const useFetchCustomerData = (apiUrl) => {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)

    useEffect(() => {
        (async () => {
            try {
                const host = window.location.hostname === 'localhost' ? window.location.origin : process.env.REACT_APP_BASE_PATH;
                const response = await fetch(`${host}${apiUrl}`, { signal: AbortSignal.timeout(5000) })

                let responseText
                if (!response.ok) {
                
                    try {
                        responseText = await response.text()
                    } catch {
                    }
                
                    sendReportError({
                        apiUrl,
                        errorType: 'http_error',
                        status: response.status,
                        statusText: response.statusText,
                        responseText: responseText?.slice(0, 1000)
                    })
                
                    return
                }

                let result
                try {
                    responseText = await response.text()
                    result = JSON.parse(responseText)
                } catch (error) {
                    sendReportError({
                        apiUrl,
                        errorType: 'invalid_json',
                        responseText: responseText?.slice(0, 1000)
                    })
                    return
                }

                if (isEmptyResponse(result)) {
                    sendReportError({ apiUrl,  errorType: 'empty_response', responseText: responseText?.slice(0, 1000) })
                    return
                }

                setData(result)

            } catch (error) {
                if (error.name === 'TimeoutError') {
                    sendReportError({ apiUrl, errorType: 'timeout', error: normalizeError(error) })
                } else if (error.name === 'AbortError') {
                    sendReportError({ apiUrl, errorType: 'abort', error: normalizeError(error) })
                } else {
                    sendReportError({ apiUrl, errorType: 'network_error', error: normalizeError(error) })
                }

                console.error('[useFetchCustomerData]', apiUrl, error)
            } finally {
                setLoading(false)
            }
        })()
    }, [])

    return { data, loading }
}